module.exports = "/images/sketch.jpg";